import * as Yup from 'yup';
import { Locale } from '@synergy/models';
import { fields } from '@synergy/utils';

import { TaxRateFormikValues } from './models/tax-rate-formik-values';

const fieldNames = fields<TaxRateFormikValues>();

export const taxRatesModalValidationSchema = (locale: Locale) =>
    Yup.object().shape({
        branchNumber: Yup.number().integer('app.error.integer').nullable().moreThan(0, 'app.error.greaterZero'),
        counterAccount: Yup.number().integer('app.error.integer').nullable().moreThan(0, 'app.error.greaterZero'),
        taxCode: Yup.number().integer('app.error.integer').nullable().moreThan(0, 'app.error.greaterZero'),
        taxPercentage: Yup.number().nullable().min(0, 'app.error.greaterZero').max(100, 'app.error.lesserHundred'),
        [fieldNames.description]: Yup.object().shape({
            [locale]: Yup.string().required('app.error.required'),
        }),
    });
